import { render, staticRenderFns } from "./ActivityProduct.vue?vue&type=template&id=73238cef&scoped=true"
import script from "./ActivityProduct.vue?vue&type=script&lang=js"
export * from "./ActivityProduct.vue?vue&type=script&lang=js"
import style0 from "./ActivityProduct.vue?vue&type=style&index=0&id=73238cef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73238cef",
  null
  
)

export default component.exports